import React from "react";
import "./PointSystem.css";
import { Helmet } from "react-helmet-async";
const PointSystem = () => {
  return (
     <>
      <Helmet>
        <title>Point System | Nifty10</title>
        <meta
          name="description"
          content="Understand how Nifty10's point system works. Learn how points are awarded and used in the stock prediction games."
        />
      </Helmet>
    <section className="point-system">
      <h2 className="terms-header">Nifty 10 Points System</h2>

      {/* 📈 Stock Points Allocation */}
      <div className="section">
        <ul className='terms-conditions-list'>
          <li className='terms-conditions-list-item privacy-sub-header'>Game Objective</li>
          <p className="privacy-text">Select 5 stocks and maximize your score based on real-time stock performance.
Your winning potential depends on choosing the right Bigbull/Bigbear and consistent performers.
</p>
          <li className="privacy-sub-header">Stock Selection Rules</li>
<ul className='privacy--list'>
                    <li className='privacy-list-item'>Pick 5 stocks from a curated pool of 50 top Nifty stocks.</li>
                    <li className='privacy-list-item'>Choose 1 of these 5 as your Bigbull (Bullish Market) or Bigbear (Bearish Market).</li>
                    <li className='privacy-list-item'>Strategy lies in choosing a reliable Bigbull and strong support from the remaining 4.</li>
                </ul>
          <li className="privacy-sub-header">Scoring Formula</li>
          <p className="privacy-text point-system-strong">Final Score =
Sum of 4 Normal Stocks+ Base Points (Bigbull × 10)+ Bonus Points (Base Points × Day Performance Multiplier)
</p><p></p>
<p className="privacy-text">⚠️ <span className="point-system-strong">Note:</span> If any stock is bearish, its point <span className="point-system-strong">becomes 0 </span>(including Bigbull).
</p><p></p>
<p className="privacy-text">The <span className="point-system-strong">10X multiplier </span>and bonus apply ONLY IF <span className="point-system-strong">Bigbull</span> is choosen correct.</p>
          <li className="privacy-sub-header">Day Performance Multiplier</li>
          <ul className='privacy--list'>
                    <li className='privacy-list-item'>Affects only the  <span className="point-system-strong">Bigbull/Bigbear.</span></li>
                    <li className='privacy-list-item'>Multiplier reflects the overall  <span className="point-system-strong">market performance </span>(e.g., 1.2x, 1.4x).</li>
                    <li className='privacy-list-item'>Used to  <span className="point-system-strong">amplify Bigbull's base points</span> if it performs well.</li>
                </ul>
          <li className="privacy-sub-header">Stock Performance</li>
          <p className="privacy-text">In Nifty10, each normal stock adds its base points to your final score only if it’s bullish; if it turns bearish, it contributes zero points. The Bigbull or Bigbear stock is more impactful — if it’s bullish, it multiplies the base points by 10 and adds a bonus based on the day’s market multiplier. However, if this Big stock turns bearish, it too gives zero points, no matter its original value.</p>
          <li className="privacy-sub-header">Example Walkthrough</li>
           <p className="privacy-sub-list-item1">Example 1: All Stocks Bullish</p>
          <ul className="privacy--list">
          <li className="privacy-list-item">Selected Stocks: Powergrid (3.0), TechM (3.0), Cipla (2.5), Reliance (3.0), Eicher Motors (4.5)</li>
          <li className="privacy-list-item">Bigbull: Eicher Motors</li>
          <li className="privacy-list-item">Day Multiplier: 1.4x</li>
          <li className="privacy-list-item">Normal Total = 11.5 | Bigbull = (4.5*10)+(4.5 × 10 × 1.4) = 108</li>
          <li className="point-system-strong">Final Score = 11.5 + 108 = 119.5</li>
        </ul>

        <p className="privacy-sub-list-item1">Example 2: Mixed Performance</p>
        <ul className="privacy--list">
          <li className="privacy-list-item">Bearish Stocks: Powergrid, Cipla (score 0)</li>
          <li className="privacy-list-item">Remaining: TechM (3.0), Reliance (3.0), Eicher Motors (4.5)</li>
          <li className="privacy-list-item">Bigbull: Eicher Motors | Multiplier: 1.4x</li>
          <li className="privacy-list-item">Normal Total = 6.0 | Bigbull = (4.5*10)+(4.5 × 10 × 1.4) = 108</li>
          <li className="point-system-strong">Final Score = 6.0 + 108 = 114.0</li>
        </ul>

        <p className="privacy-sub-list-item1">Example 3: Bigbull Bearish</p>
        <ul className="privacy--list">
          <li className="privacy-list-item">Bigbull (Eicher Motors) is bearish → score = 0</li>
          <li className="privacy-list-item">Normal Stocks: Powergrid (3.0), TechM (3.0), Cipla (2.5), Reliance (3.0)</li>
          <li className="privacy-list-item">Normal Total = 11.5 | Bigbull = 0 × 10 × 1.4 = 0</li>
          <li className="point-system-strong">Final Score = 11.5 + 0 = 11.5</li>
        </ul>
          <li className="privacy-sub-header">Key Strategy Tips</li>
          <ul className="privacy--list">
          <li className="privacy-list-item"><span className="point-system-strong">Bigbull matters most</span> – it carries the <span className="point-system-strong">heaviest weight</span> in your score.</li>
          <li className="privacy-list-item">Diversify your normal 4 picks to protect against sudden market drops.</li>
          <li className="privacy-list-item">Analyze <span className="point-system-strong">daily stock trends</span> before selection for better prediction.</li>
          <li className="privacy-list-item"><span className="point-system-strong">Don’t repeat past performance blindly</span> – each day is different.</li>
        </ul>
          <li className="privacy-sub-header">Bonus Tips</li>
          <ul className="privacy--list">
          <li className="privacy-list-item">The top scorer each day wins <span className="point-system-strong">guaranteed cash prizes or rewards.</span></li>
          <li className="privacy-list-item">Alerts and reminders help you not miss the cutoff – <span className="point-system-strong">stay updated.</span></li>
        </ul>
        </ul>
      </div>
    </section></>
  );
};

export default PointSystem;
